import { Input } from "antd";
import styled from "styled-components";

// Padroniza labels do formulário de movimentação no mesmo visual dos demais
// formulários (ver pages/stock/components/styles.js).
export const StyledFormContainer = styled.div`
  .ant-form-item-label > label {
    color: #9074bf;
    font-family: "Asap", sans-serif;
    font-size: 14px;
    font-weight: bold;
  }

  .ant-form-item-label > label.ant-form-item-required::before {
    display: none;
  }

  .label-error {
    color: #d44c4c !important;
  }

  .ant-switch-checked {
    background-color: #a9c133 !important;
  }
`;

// Sub-card de cada linha de material dentro do formulário.
export const MaterialLineCard = styled.div`
  background-color: #f7f7f7;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 1rem;
  margin-bottom: 1rem;
`;

// Bloco da NF e da conversão de unidade.
export const FiscalBlock = styled.div`
  background-color: #ddd5eb;
  border: 1px solid #9074bf;
  border-radius: 4px;
  padding: 1rem;
  margin-bottom: 1rem;

  p {
    margin: 0;
  }
`;

// Bloco da despesa financeira vinculada (movimentação de ENTRADA por COMPRA).
export const FinancialTransactionBlock = styled.div`
  background-color: #fdf3e7;
  border: 1px solid #d4a656;
  border-radius: 4px;
  padding: 1rem;
  margin-bottom: 1rem;

  .ant-row > label {
    display: block;
    color: #9074bf;
    font-family: "Asap", sans-serif;
    font-size: 14px;
    font-weight: bold;
    margin: 4px 0;
  }

  .label-error {
    color: #d44c4c !important;
  }

  .ant-radio-group-solid .ant-radio-button-wrapper-checked {
    color: #fff !important;
  }
  .ant-radio-wrapper {
    span {
      color: #4b4b4b;
    }
  }
`;

// Total do custo dos itens da movimentação de entrada.
export const TotalCostBox = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: #f7f7f7;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;

  strong {
    margin-left: 8px;
    color: #9074bf;
    font-size: 16px;
  }
`;

export const LocationRow = styled.div`
  background-color: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
`;

export const InputOption = styled(Input)`
  border: 2px solid #9074bf !important;
  border-radius: 4px !important;
  background-color: #ddd5eb !important;
  color: #000 !important;
  font-family: "Asap", sans-serif !important;
  font-size: 14px !important;
  font-weight: bold !important;
`;
